
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'dark' | 'light';
  showIcon?: boolean;
  linkTo?: string;
  className?: string;
}

const Logo = ({ 
  size = 'md', 
  variant = 'dark', 
  showIcon = true,
  linkTo = '/',
  className = ''
}: LogoProps) => {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl'
  };

  const iconSizes = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10'
  };

  const colorClasses = {
    dark: 'text-gray-900',
    light: 'text-white'
  };

  const content = (
    <div className={`flex items-center gap-2 ${className}`}>
      {showIcon && (
        <div className={`${iconSizes[size]} flex items-center justify-center bg-gradient-to-br from-teal-400 to-emerald-500 rounded-lg`}>
          <i className="ri-price-tag-3-fill text-white" style={{ fontSize: size === 'sm' ? '12px' : size === 'md' ? '14px' : size === 'lg' ? '18px' : '22px' }}></i>
        </div>
      )}
      <span 
        className={`font-bold ${sizeClasses[size]} ${colorClasses[variant]}`}
        style={{ fontFamily: '"Outfit", sans-serif' }}
      >
        Oh<span className="text-teal-500">price</span>
      </span>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="cursor-pointer hover:opacity-90 transition-opacity">
        {content}
      </Link>
    );
  }

  return content;
};

export default Logo;
